import { useEffect, useRef } from 'react';
import { PollarStatus } from '../enums/enums';
import { mfCentralEvaluateFundsPollar, pledgeLimitAPICall } from '../services/mfCentralEvaluateFunds';
import { useNavigation } from '@react-navigation/native';

interface UsePollingProps {
    applicationId: string;
}

export const usePolling = ({ applicationId }: UsePollingProps) => {
    const navigation = useNavigation();
    const pollIntervalRef = useRef<NodeJS.Timeout | null>(null);

    const handlePollingResponse = async (pollarStatusFromAPI: PollarStatus) => {
        if (pollarStatusFromAPI === PollarStatus.SUCCESS) {
            const pledgeLimitResponse = await pledgeLimitAPICall({ applicationId });
            const stepResponseObject = pledgeLimitResponse?.data?.stepResponseObject;
            const minimumEligibleLimit = stepResponseObject?.minimumEligibleLimit?.amount;
            const availableCreditAmount = stepResponseObject?.availableCreditAmount;
            if (availableCreditAmount >= minimumEligibleLimit) {
                navigation.replace("MFC_FETCH_LANDING", {
                  availableCreditAmount: availableCreditAmount
                });
            } else {
                navigation.replace("MFC_FETCH_ANCHOR");
            }
        }
    };

    useEffect(() => {
        const poll = async () => {
            try {
                const response = await mfCentralEvaluateFundsPollar({ applicationId });

                if (response?.status === 200) {
                    const pollarStatusFromAPI = response.data.status as PollarStatus;

                    if (pollarStatusFromAPI !== PollarStatus.IN_PROGRESS) {
                        if (pollIntervalRef.current) {
                            clearInterval(pollIntervalRef.current);
                        }
                        await handlePollingResponse(pollarStatusFromAPI);
                    }
                    if(response?.data?.status === PollarStatus.FAILED) {
                        navigation.navigate(
                            //@ts-ignore
                            "MF_FETCH_PORTFOLIO",
                            {errorData: response?.data?.error}
                        );
                    }
                }
            } catch (err) {

                console.error("Polling error:", err);
            }
        };

        poll();
        pollIntervalRef.current = setInterval(poll, 5000);

        return () => {
            if (pollIntervalRef.current) {
                clearInterval(pollIntervalRef.current);
            }
        };
    }, [applicationId]);
};